<div style="padding: 15px">
    <div class="filter-options">
        <div>
            <mat-form-field style="width:270px;">
                    <mat-label>Select Plant</mat-label>
                    <mat-select [formControl]="plantSelect" (selectionChange)="getRootCauses()">
                        @for (plant of plantList; track $index) {
                            <mat-option  [value]="plant.display_name">{{plant.display_name}}</mat-option>
                        }
                    </mat-select>
            </mat-form-field>
        </div>
        <div>
            <mat-form-field style="width:270px;">
                    <mat-label>Select Root Cause</mat-label>
                    <mat-select [formControl]="rootCauseSelect" (selectionChange)="getData()">
                        @for (rc of rootCauseList; track $index) {
                            <mat-option  [value]="rc.Level1">{{rc.Level1}}</mat-option>
                        }
                    </mat-select>
            </mat-form-field>
        </div>
        <div>
            <gea-mes-datepicker
                class="dateRangeBut"
                matTooltip="Select Date" 
                (onDateSelect)="onDateSelection($event)" 
                (onDateInit)="onDateSelection($event)"
                singleDate="false" 
                showLabel="true"
                showCurrentShift="false"
                defaultRange="Today"
                showRangeLabel="true"
                autoApply="true"
                [index]=3>
            </gea-mes-datepicker>
        </div>
        <div>
            <mat-form-field style="width:270px;">
                    <mat-label>Select Shift</mat-label>
                    <mat-select [formControl]="shiftSelect" multiple (selectionChange)="filter()">
                        @for (shift of shifts; track $index) {
                            <mat-option  [value]="shift">{{shift}}</mat-option>
                        }
                    </mat-select>
            </mat-form-field>
        </div>

        <div class="checkbox-filter-container" style="display: flex; align-items: center; height: 56px; margin-left: 15px;">
            <mat-checkbox [formControl]="hideReviewComplete" (change)="filter()">
                Hide Review Completed
            </mat-checkbox>
        </div>


    </div>

    <mat-card  appearance="outlined"  class="problme-list-card mat-elevation-z1">
        <mat-card-title class="metric-title">
            <div>
                Faults
            </div>
            <div>
                <button mat-raised-button color="primary" (click)="toggleEditMode()" [disabled]="!faultListCurrent || editStatus == ChangeStatusEnum.CHANGES_INVALID">
                    @if (!editMode) {
                        Enter Edit Mode
                    }
                    @else if (editMode && editStatus != ChangeStatusEnum.CHANGES_VALID) {
                        Enter View Mode
                    }
                    @else if (editMode && editStatus == ChangeStatusEnum.CHANGES_VALID) {
                        Save All and Enter View Mode
                    }
                </button>
            </div>

        </mat-card-title>
        <mat-card-content>
            <mat-table [dataSource]="displayFaultListData" class="gea-mat-table">

                <ng-container matColumnDef="Hour">
                    <mat-header-cell *matHeaderCellDef>Shift</mat-header-cell>
                    <mat-cell *matCellDef="let d">
                        <div class="flex-column">
                            <div>{{d.ShiftDate}}</div>
                            <div>{{d.Shift}}</div>
                            <div>Hour: {{d.Hour}}</div>
                        </div>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Fault">
                    <mat-header-cell *matHeaderCellDef>Fault Value</mat-header-cell>
                    <mat-cell *matCellDef="let d">
                        <div class="flex-column">
                            <div class="faultSource">{{d.FaultObjectDescription}}</div>
                            <div>{{d.FaultMessage}}</div>
                        </div>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Duration">
                    <mat-header-cell *matHeaderCellDef>Total Duration</mat-header-cell>
                    <mat-cell *matCellDef="let d">
                        <div class="cell-padding">
                            <div class="d-block">
                                {{formatDuration(d.Problem_time_amt)}}
                            </div>
                            <div>
                                <span>Occurrences : </span>
                                <span>{{d.Occurrences}}</span>
                            </div>
                        </div>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="RootCause">
                    <mat-header-cell *matHeaderCellDef>Root Cause/Corrective Action</mat-header-cell>
                    <mat-cell *matCellDef="let d; let idx = index;">
                        <div class="fx-row-space-between-start">
                            <div style="min-width: 200px;" class="fx-column-start-start">
                                <div>
                                    <div class="rootCauseHeader">Level 1</div>
                                    <div class="rootCauseValue">{{d.Problem}}</div>
                                </div>
                                <div>
                                    <div class="rootCauseHeader">Level 2</div>
                                    <div class="rootCauseValue">
                                        @if (d.Problem_Level2 && d.Problem_Level2.trim() != '') {
                                            <span>{{d.Problem_Level2}}</span>
                                        } @else {
                                            <span>--</span>
                                        }
                                    </div>
                                </div>
                            
                                <div>
                                    <div class="rootCauseHeader">Level 3</div>
                                    <div class="rootCauseValue">
                                        @if (d.Problem_Level3 && d.Problem_Level3.trim() != '') {
                                            <span>{{d.Problem_Level3}}</span>
                                        } @else {
                                            <span>--</span>
                                        }                                       
                                    </div>
                                </div>
                            </div>
                            <div style="display: flex; flex-direction: column;">
                                <div class="rootCauseValue">
                                    {{d.Notes}}
                                </div>
                            </div>
                        </div>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Acknowledge">
                    <mat-header-cell *matHeaderCellDef>Review Acknowledgement</mat-header-cell>
                    <mat-cell *matCellDef="let d; let idx = index">
                        @if (editMode) {
                            <app-followup-entry [fault]="d" [index]="idx"></app-followup-entry>
                        }
                        @else {
                            <div class="flex-column">
                                <div>
                                    <b>Review Status:</b>
                                    @if (d.AcknowledgeDateTime != '') {
                                        Completed ({{d.AcknowledgeDateTime}})
                                    } @else {
                                        Not Complete
                                    }
                                </div>

                                @if (d.AcknowledgeComment != '') {
                                    <div><b>Comment:</b> {{d.AcknowledgeComment}}</div>
                                }                               
                            </div>
                        }
                    </mat-cell>
                </ng-container>
        
                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            </mat-table>


        </mat-card-content>
    </mat-card>
</div>